import './ui.css';

/**
 * Tarjeta compacta para mostrar un KPI dentro de una grilla 2x2.
 *
 * @param {{ icon: React.ReactNode, value: React.ReactNode, label: string, tone?: 'primary'|'success'|'warning'|'danger'|'muted', hint?: string }} props
 */
export default function StatCard({ icon, value, label, tone = 'primary', hint }) {
  return (
    <div className={`stat-card stat-card--${tone}`}>
      <span className="stat-card__icon">{icon}</span>
      <span className="stat-card__body">
        <span className="stat-card__value">{value}</span>
        <span className="stat-card__label">{label}</span>
        {hint && <span className="stat-card__hint">{hint}</span>}
      </span>
    </div>
  );
}
